"use client";
import GradientBorder from "@/components/common/gradient-border";
import { buttonVariants } from "@/components/ui/button";
import Carpet from "@/components/ui/Carpet";
import { cookieName } from "@/i18n/settings";
import Link from "next/link";
import { useCookies } from "react-cookie";

export default function NotFoundPage() {
  const [cookies] = useCookies([cookieName]);

  return (
    <html>
      <body>
        <Carpet type="fade-light-to-dark" className="h-dvh">
          <div className="text-gold-hard flex h-full flex-col items-center justify-center gap-6">
            <p>404 | the page you are looking for is not found</p>
            <Link
              href={`/${cookies?.i18next ?? "en"}`}
              className={buttonVariants({
                variant: "outline",
                className: "relative border-none bg-transparent",
              })}
            >
              <GradientBorder radius="4" />
              Home
            </Link>
          </div>
        </Carpet>
      </body>
    </html>
  );
}
